import { Container, Title, ScrollArea, Text, Anchor, Image, Divider } from '@mantine/core';
import classes from './TermsAndConditions.module.css';

export default function TermsAndConditions() {
  return (
    <ScrollArea h={'100%'}>
      <Container fluid p={30} className={classes.termsWrapper}>
        <Anchor href="/" display={'inline-block'}>
          <Image
            radius="md"
            w={300}
            src={'/assets/logo/washday_logo.webp'}
            fallbackSrc={'/assets/logo/washday_logo.png'}
            alt="Washday Logo"
            loading="eager" // para que no espere a lazy-load
            fetchPriority="high" // Chrome 108+ da más peso al preload
          />
        </Anchor>

        <Title order={1} className={classes.title} ta="center" mt="md" mb={30}>
          Terminos y Condiciones Para Usuarios
        </Title>
        <Title order={2} className={classes.title} ta="center" mt="md" mb={30}>
          1. Acerca de estos términos
        </Title>
        <Text>
          Washday ("Washday/nosotros") es el propietario y operador de el servicio de software de
          punto de venta Washday ("Servicio"). Hemos desarrollado un portal ("Portal") proporcionado
          a través de nuestros sitios web en washday.mx y washdaypos.com ("Sitio") y nuestra
          aplicación web ("Aplicación") para proporcionarle los Servicios. Estos Términos establecen
          los términos y
          condiciones de su uso del Servicio. Su uso del Servicio es condicionado expresamente a su
          aceptación de estos Términos. Por registrarse para utilizar el Servicio, significa que
          usted incondicionalmente acuerda y acepta estar legalmente obligado por estos Términos, y
          celebrar un acuerdo legalmente vinculante con nosotros basado en estos Términos, incluida
          nuestra <Anchor href="/privacy">Política de privacidad</Anchor> y el acuerdo de nivel de
          servicio ("Acuerdo de nivel de servicio") proporcionado al final de estos Términos
          (colectivamente, el "Acuerdo").
        </Text>
        <Title order={2} className={classes.title} ta="center" mt="md" mb={30}>
          2. Cambios a estos Términos o los Servicios
        </Title>
        <Text>
          Washday se reserva el derecho de modificar estos Términos en cualquier momento. Le
          avisaremos de nuestros nuevos términos o le notificaremos de cualquier cambio a través de
          nuestro Portal, Sitio o Aplicación. Su uso continuo de este Servicio después de ser
          modificados los Términos constituirá que está de acuerdo y acepta estar legalmente
          obligado por esos cambios.
        </Text>
        <Title order={2} className={classes.title} ta="center" mt="md" mb={30}>
          4. Sobre El Servicio
        </Title>
        <Text>
          El Servicio le brinda servicios de punto de venta en linea. Cuando se registre para
          utilizar nuestro Servicio, le proporcionaremos una cuenta para utilizar el Servicio
          ("Cuenta"). Solo los usuarios que se hayan registrado a través de nuestro Portal y tengan
          una Cuenta ("Usuarios") pueden utilizar el Servicio.
        </Text>
        <Title order={2} className={classes.title} ta="center" mt="md" mb={30}>
          5. Concesión de licencia
        </Title>
        <Text>
          <Text>
            Por la presente, Washday le otorga un derecho limitado, no exclusivo e intransferible
            para usar el Servicio siempre que cumpla con sus obligaciones en virtud del Acuerdo, que
            incluyen lo siguiente:
          </Text>
          <Text>
            1. Washday puede, a su entera y absoluta discreción, sin previo aviso y sin
            responsabilidad, rechazar, prevenir, descontinuar o suspender su Cuenta y/o su uso del
            Servicio si, a su sola discreción, Washday es de la opinión que su uso no cumple con las
            especificaciones o pautas de Washday, o que Washday puede considerar inapropiado, ilegal
            o perjudicial para sus intereses. Si Washday ejerce su absoluta discreción en virtud de
            este párrafo, no tendrá la responsabilidad de reembolsar ninguna parte de sus
            suscripciones prepagas, si corresponde. Sin limitar ni renunciar a ningún derecho en su
            contra que Washday pueda tener según la ley o estos Términos en relación con cualquier
            uso inapropiado, ilegal o dañino, Washday se reserva el derecho de deducir cualquier
            costo, daños o gastos en los que pueda haber incurrido en relación con dicho uso
            inapropiado, ilegal o dañino de sus suscripciones prepagas no utilizadas, si las
            hubiera, o para reclamarlo por cualquier otro medio.
          </Text>
          <Text>
            2. Acepta cumplir con las políticas o directrices que Washday pueda introducir o
            modificar de vez en cuando. Las políticas o pautas de Washday pueden estar relacionadas
            con especificaciones técnicas, privacidad, contenido aceptable y cualquier otro asunto,
            ya que Washday puede modificar las mismas, a su absoluta discreción, de vez en cuando.
          </Text>
          <Text>
            3. Usted acepta que no hará ni hará que terceros: (a) modifiquen, interrumpan o
            interfieran con el Servicio, los servidores de soporte o las redes, ya sea manualmente o
            mediante el uso de scripts, virus o gusanos; (b) modificar, adaptar, traducir, realizar
            ingeniería inversa, descifrar, descompilar, reproducir, duplicar, copiar, deconstruir,
            vender, comercializar o revender el Servicio; (c) sobrecargar excesivamente los sistemas
            que Washday utiliza para proporcionar el Servicio; o (d) proporcionar acceso o
            proporcionar cualquier parte del Servicio a un tercero.{' '}
          </Text>
          <Text>
            4. No enviará ni transmitirá ningún material que infrinja los derechos de propiedad
            intelectual de terceros.
          </Text>
          <Text>
            5. No deberá crear una identidad falsa ni enviar información inexacta, falsa o engañosa.
          </Text>
          <Text>
            6. Washday puede, a su entera y absoluta discreción y sin previo aviso, modificar,
            suspender, variar o retirar el Servicio, estos Términos, Portal, Sitio y/o Aplicación en
            cualquier momento.{' '}
          </Text>
          <Text>
            7. Usted será el único responsable de su uso del Servicio, Portal, Sitio y Aplicación, y
            deberá indemnizar a Washday y mantener a Washday indemne de todas las pérdidas, costos y
            daños incurridos por Washday en relación con cualquier reclamo de terceros. contra
            Washday en relación con su uso del Servicio, Portal, Sitio y Aplicación, y en relación
            con su incumplimiento de estos Términos o cualquier política o pauta que Washday pueda
            introducir de vez en cuando.{' '}
          </Text>
          <Text>
            8. Por la presente, usted declara, garantiza y se compromete con Washday que en todo
            momento: (a) tiene todos los derechos, consentimientos, licencias y permisos que puedan
            ser necesarios o deseables para poder utilizar los materiales, gráficos, logotipos,
            videos, datos o información que ingresa en el Servicio (cuando corresponda) ("Su
            Contenido") en la forma y el propósito para el cual usa Su Contenido; (b) todo Su
            Contenido cumple con todas las leyes y regulaciones aplicables y no viola los derechos
            (incluidos, entre otros, los derechos de propiedad intelectual) de ningún tercero.{' '}
          </Text>
          <Text>
            9. Usted declara y garantiza a Washday que tiene todos los derechos corporativos, poder
            y autoridad para aceptar estos Términos y cumplir con las obligaciones acordadas por
            usted, y que al hacerlo no viola ni violará ningún acuerdo u obligación con el que esté
            obligado, o cualquier ley, norma o reglamento aplicable.{' '}
          </Text>
          <Text>
            10. Por la presente, acepta que Washday puede, pero no está obligado a hacerlo, utilizar
            el nombre y el logotipo de su empresa y referirse a usted como usuario del Servicio en
            cualquier publicidad, comunicado de prensa, material publicitario o de marketing, en
            todo el mundo y utilizando cualquier forma. de los medios. Si desea utilizar o mostrar
            las marcas comerciales de Washday o mencionar a Washday en cualquier publicación, sitio
            web, comunicado de prensa o de cualquier otra manera, debe obtener el consentimiento
            previo por escrito de Washday.{' '}
          </Text>
          <Text>
            11. Usted acepta que es el único responsable de obtener o proporcionar cualquier
            hardware o software que pueda necesitar para obtener acceso y utilizar el Servicio, y
            por cualquier daño o pérdida que sufra como resultado de la operación de dicho hardware
            o software. , incluida la incompatibilidad con cualquier plataforma utilizada por
            Washday para proporcionar el Servicio.{' '}
          </Text>
          <Text>
            12. Usted acepta que Washday es el único propietario y tiene derecho a utilizar
            cualquier comentario que proporcione sobre el Servicio de cualquier forma, incluso para
            mejorar los productos y servicios existentes o crear nuevos. Washday se reserva todos
            los derechos, incluida cualquier propiedad intelectual, sobre el Servicio, el Sitio y la
            Aplicación que no se le otorguen expresamente en estos Términos. Excepto en la medida en
            que se establezca en el Acuerdo, o se acuerde por escrito de otro modo entre nosotros,
            no se le permite hacer uso de dichos derechos. Por la presente, acepta otorgar a Washday
            una licencia mundial, libre de regalías y no exclusiva para publicar, alterar, adaptar,
            compilar, alojar y usar (a) Su contenido (que incluye, entre otros, reproducir en forma
            material, publicar, realizar , comunicar al público y hacer una adaptación de Su
            Contenido) con el fin de proporcionarle el Servicio,y (b) si Washday proporciona algún
            foro comunitario para que los usuarios del Servicio intercambien consejos de usuario y
            publiquen sus comentarios y opiniones, cualquier comentario, opinión y otro material que
            cargue o publique en dicho foro.
          </Text>
        </Text>
        <Title order={2} className={classes.title} ta="center" mt="md" mb={30}>
          7. Condiciones de pago
        </Title>
        <Text>
          Al crear una Cuenta y suscribirse al Servicio o al renovar su suscripción al Servicio,
          usted indica que acepta los cargos impuestos por Washday por el Servicio que ha
          solicitado. Usted acepta cumplir con las condiciones de pago que Washday pueda imponer de
          vez en cuando. Es posible que deba pagar a Washday por adelantado y/o de forma anual,
          semestral, trimestral o mensual para utilizar el Servicio como se establece en su Cuenta.
          Su suscripción puede renovarse automáticamente en o cerca de su vencimiento a las tarifas
          de suscripción aplicables en el momento de la renovación. Es su responsabilidad exclusiva,
          y no la de Washday, asegurarse de que su suscripción se renueve antes de su vencimiento.
          Si no renueva su suscripción, caducará automáticamente. Es posible que Washday no le dé
          aviso previo de una renovación automática. Si Washday no puede efectuar esta renovación
          automática por cualquier motivo, su suscripción caducará automáticamente. Para los
          suscriptores que eligen pagar con tarjeta de crédito, usted acepta que las tarifas de
          suscripción para la renovación se cargarán a la tarjeta de crédito registrada a menos que
          se notifique a Washday de un cambio o cancelación por escrito utilizando las herramientas
          o los medios puestos a disposición por Washday. Todas las sumas pagaderas por usted a
          Washday se pueden cotizar sin incluir ningún impuesto sobre bienes y servicios, o
          cualquier otro impuesto que pueda aplicarse a la suscripción o los cargos cobrados por
          Washday. Como tal, usted acepta que Washday puede cobrarle a usted y/o a la tarjeta de
          crédito registrada por cualquier impuesto o cargo que Washday esté obligado por cualquier
          ley o reglamento aplicable a imponer sobre la suscripción o los cargos. El soporte se
          puede proporcionar como parte de su suscripción,a menos que esté suscrito a la suscripción
          básica de nivel de entrada. Si se ha retrasado en los pagos de su suscripción o tiene un
          saldo pendiente con Washday, Washday puede dejar de brindar servicios de soporte hasta que
          se liquiden todas las deudas. La suscripción a Washday se realiza por sucursal. Necesitará
          una suscripción por sucursal (incluidas las sucursales virtuales, ubicaciones o
          servicios). El uso de más de una sucursal, o el procesamiento de pedidos en nombre de
          otras sucursales en una suscripción, requerirá que realice un acuerdo de precios
          personalizado con Washday o su cuenta será suspendida o cancelada por Washday.entonces
          Washday puede dejar de brindar servicios de soporte hasta que se liquiden todas las
          deudas. La suscripción a Washday se realiza por sucursal. Necesitará una suscripción por
          sucursal (incluidas las sucursales virtuales, ubicaciones o servicios). El uso de más de
          una sucursal, o el procesamiento de pedidos en nombre de otras sucursales en una
          suscripción, requerirá que realice un acuerdo de precios personalizado con Washday o su
          cuenta será suspendida o cancelada por Washday.entonces Washday puede dejar de brindar
          servicios de soporte hasta que se liquiden todas las deudas. La suscripción a Washday se
          realiza por sucursal. Necesitará una suscripción por sucursal (incluidas las sucursales
          virtuales, ubicaciones o servicios). El uso de más de una sucursal, o el procesamiento de
          pedidos en nombre de otras sucursales en una suscripción, requerirá que realice un acuerdo
          de precios personalizado con Washday o su cuenta será suspendida o cancelada por Washday.{' '}
        </Text>
        <Title order={2} className={classes.title} ta="center" mt="md" mb={30}>
          8. Duración y rescisión
        </Title>
        <Text>
          Washday tendrá derecho a rescindir el Acuerdo, sin previo aviso, si incumple o no cumple
          con cualquier disposición del Acuerdo. El Acuerdo y su capacidad para utilizar el Servicio
          también terminarán automáticamente al vencimiento de su suscripción. Después de la
          terminación, Washday puede, a su entera discreción, mantener cualquier dato que haya
          cargado en sus sistemas, incluidos Sus datos y Su contenido. Sin embargo, usted acepta
          que, aparte de las obligaciones expresamente establecidas en estos Términos, Washday no
          tiene ninguna responsabilidad ante usted de mantener su Cuenta o cualquiera de sus datos
          después de la terminación y usted mantendrá a Washday indemne y libre de cualquier tarifa,
          daño o reclamo que pueda. Sufre en relación con el mismo o cualquier reclamación o acción
          que pueda tener o afrontar en relación con el mismo. Si la terminación se debe a que no
          renovó su suscripción de manera oportuna, puede reactivar su Cuenta y acceder a sus datos
          si Washday habilita la renovación en tales circunstancias. Para hacerlo, es posible que
          deba pagar las tarifas de suscripción o los cargos que pueda imponer Washday, incluidas
          las tarifas de reactivación (si las hubiera), dentro de cualquier período que pueda
          establecer Washday. Si no renueva su cuenta, Washday puede eliminar permanentemente y
          eliminar su cuenta y cualquier dato que haya cargado en sus sistemas.
        </Text>
        <Title order={2} className={classes.title} ta="center" mt="md" mb={30}>
          9. Privacidad de datos
        </Title>
        <Text>
          <Text>
            Usted o sus clientes, socios o asociados, lo que sea aplicable, son el propietario de
            cualquier dato que cargue en el Servicio ("Sus Datos"). Por la presente, acepta que
            Washday es el propietario de todos los datos que no sean Sus datos, incluidos los datos
            generados por el sistema generados por el Servicio o los datos recopilados a partir de
            los datos ingresados en el Servicio por todos los Usuarios de forma agregada ("Datos
            de Washday"). Sujeto a nuestra Política de privacidad, Washday puede usar Washday Data
            de la forma que elija, incluso para mejorar o adaptar sus servicios, o para crear o
            diseñar nuevos productos y servicios. Al utilizar nuestro Servicio, es posible que
            necesitemos procesar los datos personales de sus clientes. Cuando procesemos datos
            personales en su nombre al cumplir con nuestras obligaciones en virtud del Acuerdo,
            usted será el controlador y Washday será el procesador a los efectos de la Legislación
            de protección de datos. Usted acepta que el alcance, la naturaleza y el propósito del
            procesamiento por nuestra parte están relacionados con la prestación del Servicio. El
            tipo de datos personales se establecerá en Sus datos, y las categorías de sujetos de
            datos son las personas a las que se puede hacer referencia en Sus datos. La duración del
            procesamiento durante el período de tiempo razonablemente necesario para proporcionar el
            Servicio. Si procesamos datos personales en su nombre, haremos lo siguiente:
          </Text>
          <Text>
            1. Procesar esos datos personales solo en sus instrucciones escritas a menos que Washday
            sea requerido por la ley.
          </Text>
          <Text>
            2.Asegurarse de que contamos con las medidas técnicas y organizativas adecuadas,
            revisadas y aprobadas por usted, para proteger contra el procesamiento no autorizado o
            ilegal de datos personales y contra la pérdida o destrucción accidental o daño de datos
            personales, apropiados para el daño que pueda resultar del procesamiento no autorizado o
            ilegal o pérdida accidental, destrucción o daño y la naturaleza de los datos a proteger,
            teniendo en cuenta el estado de desarrollo tecnológico y el costo de implementación de
            cualquier medida;
          </Text>
          <Text>
            3. no transferir ningún dato personal fuera del sistema a menos que se cumplan las
            siguientes condiciones: (a) Washday o usted ha proporcionado las garantías adecuadas en
            relación con la transferencia; (b) el interesado tiene derechos exigibles y recursos
            legales efectivos; (c) Washday cumple con sus obligaciones bajo la Legislación de
            Protección de Datos al proporcionar un nivel adecuado de protección a cualquier dato
            personal que se transfiera; y (d) Washday cumple con las instrucciones razonables que
            usted le haya notificado previamente con respecto al procesamiento de los datos
            personales;
          </Text>
          <Text>
            4. ayudarlo a responder a cualquier solicitud de un interesado y a garantizar el
            cumplimiento de sus obligaciones en virtud de la Legislación de protección de datos con
            respecto a la seguridad, notificaciones de incumplimiento, evaluaciones de impacto y
            consultas con autoridades de supervisión o reguladores;
          </Text>
          <Text>
            5. notificarle sin demora indebida cuando tenga conocimiento de una violación de datos
            personales;
          </Text>
          <Text>
            6. asegurar que todos nuestros empleados mantengan la confidencialidad de los datos
            personales;
          </Text>
          <Text>
            7. según sus instrucciones por escrito, eliminar o devolver los datos personales y
            copias de los mismos al finalizar el Acuerdo, a menos que la Ley aplicable lo requiera
            para almacenar los datos personales; y
          </Text>
          <Text>
            8. mantener registros e información completos y precisos para demostrar su cumplimiento
            con la Legislación de Protección de Datos y permitir que usted o su auditor designado
            realice auditorías. Usted da su consentimiento para que Washday designe procesadores de
            datos personales de terceros en virtud del Acuerdo para fines de almacenamiento y
            análisis de datos. Washday confirma que ha entrado o (según sea el caso) celebrará con
            el procesador de terceros un acuerdo por escrito sustancialmente sobre los términos
            comerciales estándar de ese tercero. Entre Washday y usted, Washday seguirá siendo
            plenamente responsable de todos los actos u omisiones de cualquier procesador de
            terceros designado por él.
          </Text>
        </Text>
        <Title order={2} className={classes.title} ta="center" mt="md" mb={30}>
          10. Tu cuenta
        </Title>
        <Text>
          La responsabilidad de mantener segura y confidencial cualquier contraseña e ID de usuario
          que Washday pueda emitirle para acceder al Servicio y a su Cuenta, recae únicamente en
          usted y los empleados, representantes y agentes suyos a quienes se les haya confiado la
          misma. . Si se da cuenta de cualquier acceso no autorizado a su Cuenta, o cualquier uso
          indebido de su (s) contraseña (s) e ID (s) de usuario, debe activar el proceso
          implementado para deshabilitar su Cuenta y/o volver a emitir nuevas contraseñas. o ID de
          usuario lo antes posible. Usted acepta que es el único responsable de las acciones y
          omisiones de la (s) persona (s) que designe como usuario (s) o administrador (es) de su
          Cuenta para el Servicio. También acepta que Washday puede aceptar instrucciones y
          solicitudes y comunicarse con dicha (s) persona (s) hasta que Washday reciba una
          notificación de que dicha (s) persona (s) ya no es su (s) usuario (s) o administrador (s),
          y tales instrucciones, solicitudes y las comunicaciones son válidas y legalmente
          vinculantes para usted. Además, usted es responsable de cualquier uso de su (s) cuenta (s)
          por cualquier persona que esté en posesión de su (s) ID de usuario o contraseña (s).
          Sujeto a nuestra Política de Privacidad y al Acuerdo de Nivel de Servicio, usted reconoce
          que Washday puede acceder a su Cuenta para modificar, eliminar o manejar su Cuenta, Su
          Contenido y Sus Datos sin previo aviso. Washday no será responsable de ninguna pérdida o
          daño causado por dicho acceso.las solicitudes y comunicaciones son válidas y legalmente
          vinculantes para usted. Además, usted es responsable de cualquier uso de su (s) cuenta (s)
          por cualquier persona que esté en posesión de su (s) ID de usuario o contraseña (s).
        </Text>
        <Title order={2} className={classes.title} ta="center" mt="md" mb={30}>
          11. Indemnización
        </Title>
        <Text>
          Si Washday y/o cualquiera de sus afiliadas (colectivamente las "Partes indemnizadas")
          toman alguna medida para hacer cumplir cualquiera de estos Términos, usted acepta
          indemnizar y eximir de responsabilidad a las Partes indemnizadas, sus afiliados y sus
          respectivos funcionarios, directores, empleados y agentes de y contra todos y cada uno de
          los reclamos, pérdidas, costos, gastos, causas de acción o demandas, incluidos los
          honorarios legales y contables razonables, que surjan de y se relacionen con su uso del
          Servicio, y todos y cada uno de los incumplimientos por su parte de estos Términos .
        </Text>
        <Title order={2} className={classes.title} ta="center" mt="md" mb={30}>
          12. Descargo de responsabilidad
        </Title>
        <Text>
          A MENOS QUE SE INDIQUE EXPRESAMENTE AQUÍ, EN LA MEDIDA MÁXIMA PERMITIDA POR LA LEY,
          WASHDAY NO OFRECE GARANTÍA O REPRESENTACIÓN DE NINGÚN TIPO CON RESPECTO A SU SITIO,
          APLICACIÓN, SERVICIO U OTROS PRODUCTOS O SERVICIOS DISPONIBLES EN SU SITIO O APLICACIÓN
          Y/O CUALQUIER MATERIAL DEL SITIO PROPORCIONADO APP, TODAS LAS CUALES SE PROPORCIONAN "TAL
          CUAL". WASHDAY NO GARANTIZA LA EXACTITUD, INTEGRIDAD, MONEDA O FIABILIDAD DE CUALQUIERA DE
          LOS CONTENIDOS O DATOS QUE SE ENCUENTRAN EN EL SERVICIO, O EL SITIO O LA APLICACIÓN.
          WASHDAY RENUNCIA EXPRESAMENTE A TODAS LAS GARANTÍAS Y TÉRMINOS EN RELACIÓN CON EL
          SERVICIO, INCLUYENDO TODAS LAS GARANTÍAS IMPLÍCITAS EN RELACIÓN CON COMERCIABILIDAD,
          CALIDAD SATISFACTORIA, APTITUD PARA UN PROPÓSITO GENERAL O PARTICULAR Y NO INFRACCIÓN DE
          DERECHOS DE PROPIEDAD,Y LOS QUE SURJAN POR ESTATUTO O DE OTRO MODO EN LA LEY O POR CURSO
          DE TRATAMIENTO O USO COMERCIAL EN LA MEDIDA MÁXIMA PERMITIDA POR LAS LEYES. WASHDAY NO
          GARANTIZA QUE EL SERVICIO, SU SITIO, APLICACIÓN, SERVIDORES O CUALQUIER CORREO ELECTRÓNICO
          ENVIADO DESDE WASHDAY ESTÉ LIBRE DE VIRUS U OTROS COMPONENTES DAÑINOS. PARA EVITAR DUDAS,
          WASHDAY NO GARANTIZA LA EFICACIA DEL SERVICIO. WASHDAY NO ASUME RESPONSABILIDAD POR LA
          SEGURIDAD, CONFIDENCIALIDAD O PRIVACIDAD DE LAS COMUNICACIONES Y/O DATOS TRANSMITIDOS A
          TRAVÉS DE INTERNET Y NO GARANTIZA (Y EXPRESAMENTE EXCLUYE CUALQUIER Y TODAS LAS GARANTÍAS
          EXPRESAS O IMPLÍCITAS) QUE EL SERVICIO SERÁ SIN FALLA, RETRASO, ERROR O PÉRDIDA DE
          CONTENIDO, DATOS O INFORMACIÓN. ADEMÁS, WASHDAY NO SERÁ RESPONSABLE DE NINGÚN PROBLEMA DE
          COMPATIBILIDAD RELATIVO A LAS COMPUTADORAS, APLICACIONES U OTRO SOFTWARE EN CUALQUIER
          COMPUTADORA QUE UTILICE EL SERVICIO.
        </Text>
        <Title order={2} className={classes.title} ta="center" mt="md" mb={30}>
          13. Limitación de responsabilidad
        </Title>
        <Text>
          EN LA MEDIDA MÁXIMA PERMITIDA POR LA LEY, EN NINGÚN CASO WASHDAY SERÁ RESPONSABLE DE (I)
          (A) NINGUNA PÉRDIDA, RECLAMO, DAÑO O CUALQUIER DAÑO ESPECIAL, EJEMPLAR, PUNITIVO,
          INDIRECTO, INCIDENTAL O CONSECUENTE DE NINGÚN TIPO; O (B) CUALQUIER PÉRDIDA DE GANANCIAS,
          PEDIDOS, INGRESOS, AHORROS, OPORTUNIDADES DE NEGOCIO O DATOS, YA SEA BASADO EN CONTRATO,
          AGRAVIO (INCLUYENDO NEGLIGENCIA), PATRIMONIO, RESPONSABILIDAD ESTRICTA, ESTATUTO O DE OTRO
          MODO, QUE SURJA DE O ESTÁ DE ALGUNA MANERA CONECTADA A EL ACUERDO; Y (II) CUALQUIER FALLA
          O RETRASO (INCLUYENDO, PERO NO LIMITADO AL USO O INCAPACIDAD DE USAR CUALQUIER COMPONENTE
          DEL SERVICIO, SITIO O APLICACIÓN). Si, a pesar de lo anterior, Washday debe ser
          considerado responsable de cualquier pérdida o daño que surja o esté conectado de alguna
          manera con cualquiera de las funciones o usos descritos anteriormente del Servicio, Sitio
          o Aplicación, en la medida permitida por la ley. ,La responsabilidad agregada combinada de
          Washday no excederá en ningún caso el valor de la suscripción mensual por el Servicio
          pagado por usted o $1000.00 MXN, lo que sea menor. Además, la responsabilidad de Washday
          con usted por contrato, agravio, negligencia, responsabilidad estricta, bajo estatuto o de
          otra manera se reducirá en la medida, si la hubiera, a la que usted contribuyó a la
          pérdida o daño. No excluimos ni limitamos de ninguna manera nuestra responsabilidad por:
          (a) muerte o lesiones personales causadas por nuestra negligencia; o (b) fraude o
          tergiversación fraudulenta.a la que contribuyó a la pérdida o daño.
        </Text>
        <Title order={2} className={classes.title} ta="center" mt="md" mb={30}>
          14. Fuerza mayor
        </Title>
        <Text>
          Washday no tiene ninguna responsabilidad y está liberado de todas las obligaciones y
          responsabilidades contractuales (por ejemplo, por daños) si el cumplimiento de estos
          Términos se ve afectado por un evento de fuerza mayor. A los efectos de esta cláusula, el
          término "fuerza mayor" significa e incluye cualquier evento que no estuvo bajo el control
          de Washday, o que no fue razonablemente previsible, incluyendo, pero no limitado a,
          cualquier desastre natural como tormenta, inundación o tormenta, incendio, emergencia
          nacional, huelga o acción laboral equivalente, o la indisponibilidad de Internet por
          motivos ajenos al control de Washday.
        </Text>
        <Title order={2} className={classes.title} ta="center" mt="md" mb={30}>
          15. Disposiciones generales
        </Title>
        <Text>
          Si decidimos renunciar a algún derecho en particular que tengamos en virtud del Acuerdo en
          una ocasión particular, esto no nos impide ejercer ese derecho en otra ocasión. Si un
          tribunal de justicia (o un foro similar) determina que alguna parte del Acuerdo es
          inválida o inaplicable, esto no afectará la validez o aplicabilidad del resto del Acuerdo.
          No tiene derecho a transferir o ceder sus derechos y obligaciones bajo el Acuerdo a nadie
          más sin nuestro permiso previo por escrito. Estos Términos se regirán e interpretarán de
          acuerdo con la ley inglesa, y cualquier disputa relacionada con estos Términos estará
          sujeta a la jurisdicción de los tribunales de Mexico. Si se encuentra fuera del Mexico, no
          aceptamos ninguna responsabilidad por el incumplimiento de las leyes locales de su
          jurisdicción y, al aceptar estos Términos, acepta que es su responsabilidad asegurarse de
          que se cumplan dichas leyes.
        </Text>
        <Divider my={10} />
        <Title order={2} className={classes.title} ta="center" mt="md" mb={30}>
          Acuerdo de nivel de servicio
        </Title>
        <Title order={2} className={classes.title} ta="center" mt="md" mb={30}>
          Garantía de tiempo de actividad mensual
        </Title>
        <Text>
          Washday garantiza que su Servicio estará disponible el 99,9% del tiempo en un mes
          calendario ("Garantía de tiempo de actividad mensual"), excluyendo el Mantenimiento y las
          Exclusiones (ambos términos se definen a continuación). Usted es elegible para reclamar
          crédito (s) de servicio por el tiempo de inactividad del servicio si Washday no cumple con
          la garantía de tiempo de actividad mensual, siempre que Washday verifique el tiempo de
          inactividad total del servicio de 0.1% en un mes calendario. El "tiempo de inactividad del
          servicio" se define como la imposibilidad de acceder al servicio debido a la falla del
          equipo de red administrado, propiedad, arrendado o utilizado por Washday para proporcionar
          el servicio, incluida la falla de los conmutadores, enrutadores y cableado administrados,
          pero excluyendo el mantenimiento y las exclusiones. La Garantía de tiempo de actividad
          mensual no incluye el tiempo necesario para realizar restauraciones de datos y copias de
          seguridad, si corresponde.
        </Text>
        <Title order={2} className={classes.title} ta="center" mt="md" mb={30}>
          Garantía de datos irrecuperables
        </Title>
        <Text>
          Si intenta acceder a cualquiera de sus datos, pero los datos son irrecuperables, debe
          informarlo a Washday lo antes posible. Washday investigará la causa del mismo y requerirá
          su ayuda durante dicha investigación. Si el resultado de la investigación de Washday
          indica que la causa de dichos datos irrecuperables se debe a una falla de Washday, Washday
          le otorgará un crédito de servicio hasta un máximo de la tarifa que se le cobrará por el
          mes calendario durante el cual los datos irrecuperables y el evento tuvo lugar.
        </Text>
        <Title order={2} className={classes.title} ta="center" mt="md" mb={30}>
          Soporte
        </Title>
        <Text>
          Washday proporciona asistencia gratuita las 24 horas del día, los 7 días de la semana para
          aquellos con suscripciones estándar y profesional. Las consultas de soporte se priorizan
          según la urgencia y debe esperar una respuesta a una consulta en 30 minutos; las
          solicitudes de funciones dependen de la disponibilidad del desarrollador, pero
          generalmente se responden dentro de las 72 horas. El soporte no incluye capacitación
          gratuita, aunque a veces se puede brindar según la disponibilidad. Las consultas
          posteriores o repetidas probablemente se colocarán al final de la cola. Se recomienda que
          proporcione la mayor cantidad de información posible en su consulta original para
          garantizar una respuesta rápida.
        </Text>
        <Title order={2} className={classes.title} ta="center" mt="md" mb={30}>
          Exclusiones
        </Title>
        <Text>
          <Text>
            El cliente no tendrá derecho a ningún crédito de servicio si el tiempo de inactividad
            del servicio se debe a lo siguiente ("Exclusiones"):
          </Text>
          <Text>
            1. las acciones u omisiones suyas o de sus empleados, agentes, representantes o
            contratistas utilizando la (s) contraseña (s) y la (s) identificación (es) de usuario
            emitidas por Washday para acceder al Servicio o su Cuenta;
          </Text>
          <Text>2. Mantenimiento realizado por Washday;</Text>
          <Text>
            3. un ataque de denegación de servicio, actividad de piratas informáticos u otro evento
            o código malicioso dirigido contra Washday o un Usuario;
          </Text>
          <Text>
            4. falla de cualquier hardware, software, red o infraestructura de Internet que no sea
            propiedad ni esté administrada por Washday o sus subcontratistas; y
          </Text>
          <Text>5. factores fuera del control razonable de Washday.</Text>
        </Text>
        <Title order={2} className={classes.title} ta="center" mt="md" mb={30}>
          Mantenimiento
        </Title>
        <Text>
          <Text>"Mantenimiento" significa:</Text>
          <Text>
            1. cualquier mantenimiento programado de los centros de datos en la nube utilizados por
            Washday para proporcionar el Servicio del cual se le notifica con al menos 2 días de
            anticipación. Con el fin de notificarle, Washday utilizará el correo electrónico de
            contacto registrado. Asegúrese de que este correo electrónico esté actualizado y se
            acceda a él con frecuencia; y
          </Text>
          <Text>
            2. cualquier mantenimiento de los centros de datos utilizados por Washday: (a) es
            necesario para evitar una amenaza inmediata al centro de datos o al Servicio; y (b) del
            cual se notifica al Cliente.
          </Text>
        </Text>
        <Divider my={10} />
        <Title order={2} className={classes.title} ta="center" mt="md" mb={30}>
          Cláusula – Complemento “Pedidos Adicionales”
        </Title>
        <Text>
          El Complemento “Pedidos Adicionales” es una funcionalidad opcional puesta a disposición
          del usuario con el objetivo de evitar la interrupción del servicio al alcanzar el límite
          mensual de pedidos incluidos en su plan contratado. Activación voluntaria. La activación
          de esta funcionalidad es voluntaria y se realiza por parte del usuario desde la sección de
          configuración de su cuenta. Al habilitarla, el usuario manifiesta su consentimiento
          expreso para que se generen cargos adicionales conforme a lo establecido en la presente
          cláusula. Costo por pedido adicional. Una vez alcanzado el límite mensual de pedidos
          incluidos en el plan, cada pedido adicional creado mientras la función esté activa
          generará un cargo automático correspondiente al precio vigente para la región de
          facturación mostrado en la cuenta del usuario (más impuestos aplicables) por pedido.
          Forma y momento de cobro. Los cargos derivados del uso de esta funcionalidad se
          acumularán y podrán reflejarse: a) en el siguiente ciclo de facturación de la suscripción,
          o b) en un cobro adicional específico, según el método de pago registrado por el usuario.
          Desactivación. El usuario podrá desactivar la función “Pedidos Adicionales” en cualquier
          momento desde el panel de configuración. La desactivación tendrá efectos únicamente hacia
          futuro y no afectará los cargos generados con anterioridad a dicha acción.
          Responsabilidad. Washday no se responsabiliza por la creación de pedidos adicionales
          generados durante el periodo en que la función se encuentre activa, siendo el usuario el
          único responsable del control y monitoreo de su uso. Modificaciones. Washday se reserva el
          derecho de modificar el costo o las condiciones de este complemento previa notificación al
          usuario conforme a los mecanismos de comunicación establecidos en los Términos y
          Condiciones generales del servicio.
        </Text>
      </Container>
    </ScrollArea>
  );
}
